import React, { useContext, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../../contexts/UserContext'
import img from '../../favicon.png'
import './Header.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const Header = () => {

  const { user, logOut } = useContext(AuthContext)
  console.log(user);

  const handleLogout = () => {
    toast.success('Logout Successfully', { autoClose: 1000 })
    logOut()
      .then(() => { })
      .catch(error => {
        console.error('error', error);
      })
  }


  const [isMenuOpen, setIsMenuOpen] = useState(false)
  return (
    <div className=' bg-slate-300 px-4 py-4 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8 sticky top-0 z-50'>
      <ToastContainer position='top-center'></ToastContainer>
      <div className='relative flex items-center justify-between'>
        <Link
          to='/'
          aria-label='Smart Home'
          title='Smart Home'
          className='inline-flex items-center'
        >
          <img className='img' src={img} alt="" />
          <span className='ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase'>
            Developers Kwiz
          </span>
        </Link>
        <ul className='flex items-center hidden space-x-8 lg:flex'>
          <li className='font-bold tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400 '>
            <NavLink
              to='/category'
              aria-label='category'
              title='category'
              className={({ isActive }) =>
                isActive ? 'active' : undefined
              }
            >
              Category
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/statistics'
              aria-label='statistics'
              title='statistics'
              className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
            >
              Statistics
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/blog'
              aria-label='About Us'
              title='About Us'
              className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
            >
              Blog
            </NavLink>
          </li>

          {
            user?.uid ?
              <li>
                <button onClick={handleLogout}
                  aria-label='Logout'
                  title='Logout'
                  className='btn btn-sm'
                >
                  Logout
                </button>
              </li>

              : <>
                <li>
                  <NavLink
                    to='/login'
                    aria-label='Log In'
                    title='Log In'
                    className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                  >
                    LogIn
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/register'
                    aria-label='Register'
                    title='Register'
                    className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                  >
                    Register
                  </NavLink>
                </li>

              </>
          }

          {
            user?.displayName && <span>Welcome: <span className='font-bold'>{user.displayName}</span></span>
          }



        </ul>
        <div className='lg:hidden'>
          <button
            aria-label='Open Menu'
            title='Open Menu'
            className='p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50'
            onClick={() => setIsMenuOpen(true)}
          >
            <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
              <path
                fill='currentColor'
                d='M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z'
              />
              <path
                fill='currentColor'
                d='M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z'
              />
              <path
                fill='currentColor'
                d='M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z'
              />
            </svg>
          </button>
          {isMenuOpen && (
            <div className='absolute top-0 left-0 w-full'>
              <div className='p-5 bg-white border rounded shadow-sm'>
                <div className='flex items-center justify-between mb-4'>
                  <div>
                    <Link
                      to='/'
                      aria-label='Company'
                      title='Company'
                      className='inline-flex items-center'
                    >
                      <img className='img' src={img} alt="" />
                      <span className='ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase'>
                        Developers Kwiz
                      </span>
                    </Link>
                  </div>
                  <div>
                    <button
                      aria-label='Close Menu'
                      title='Close Menu'
                      className='p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline'
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
                        <path
                          fill='currentColor'
                          d='M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z'
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <nav>
                  <ul className='space-y-4'>
                    <li>
                      <NavLink
                        to='/category'
                        aria-label='category'
                        title='category'
                        className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                      >
                        Category
                      </NavLink>
                    </li>



                    <li>
                      <NavLink
                        to='/statistics'
                        aria-label='statistics'
                        title='statistics'
                        className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                      >
                        Statistics
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/blog'
                        aria-label='About Us'
                        title='About Us'
                        className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                      >
                        Blog
                      </NavLink>
                    </li>
                    {
                      user?.uid ?
                        <li >
                          <button onClick={handleLogout}
                            aria-label='Register'
                            title='Register'
                            className='btn btn-sm mb-4'
                          >
                            Logout
                          </button>
                        </li>

                        : <>
                          <li>
                            <NavLink
                              to='/login'
                              aria-label='Log In'
                              title='Log In'
                              className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                            >
                              LogIn
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to='/register'
                              aria-label='Register'
                              title='Register'
                              className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400'
                            >
                              Register
                            </NavLink>
                          </li>

                        </>
                    }

                    {
                      user?.displayName && <span>Welcome: <span className='font-bold'>{user.displayName}</span></span>
                    }
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Header